.button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  min-height: var(--control-height, var(--target-min));
  padding: 0 var(--space-5);
  border: var(--border-default) solid transparent;
  border-radius: var(--radius-control);
  font: var(--type-body);
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  transition:
    background-color var(--motion-fast) var(--motion-ease),
    border-color var(--motion-fast) var(--motion-ease),
    box-shadow var(--motion-fast) var(--motion-ease),
    transform var(--motion-instant) var(--motion-ease);
  -webkit-tap-highlight-color: transparent;
}

.button[data-pressed] {
  transform: scale(0.985);
}

.button[data-disabled] {
  cursor: not-allowed;
}

.button svg {
  flex: none;
  transition: transform var(--motion-fast) var(--motion-ease);
}

.button[data-hovered] svg:last-child:not(:first-child) {
  transform: translateX(2px);
}

.button[data-hovered] svg:first-child:not(:last-child) {
  transform: translateX(-2px);
}

.small {
  min-height: 36px;
  padding: 0 var(--space-3);
  font: var(--type-compact);
  font-weight: 600;
}

/* Small buttons keep a comfortable hit area (DESIGN_SYSTEM.md §7.3). */
.small::after {
  content: '';
  position: absolute;
  inset: -4px;
}

@media (pointer: coarse) {
  .small {
    min-height: var(--target-min);
  }
}

.block {
  width: 100%;
}

.primary {
  background: var(--color-action-primary-bg);
  color: var(--color-action-primary-fg);
  border-color: rgba(255, 255, 255, 0.08);
  box-shadow:
    inset 0 1px 0 0 rgba(255, 255, 255, 0.16),
    0 1px 2px 0 rgba(15, 23, 42, 0.12);
}

.primary[data-hovered] {
  background: var(--color-action-primary-hover);
  box-shadow:
    inset 0 1px 0 0 rgba(255, 255, 255, 0.22),
    0 2px 5px 0 rgba(15, 23, 42, 0.16);
}

.primary[data-pressed] {
  box-shadow: inset 0 1px 2px 0 rgba(0, 0, 0, 0.25);
}

.primary[data-disabled] {
  background: var(--color-bg-selected);
  color: var(--color-content-tertiary);
  border-color: transparent;
  box-shadow: none;
}

.secondary {
  border-color: var(--color-border-default);
  background: var(--color-bg-surface);
  color: var(--color-content-primary);
  box-shadow: 0 1px 2px 0 rgba(15, 23, 42, 0.04);
}

.secondary[data-hovered] {
  border-color: var(--color-border-strong);
  background: var(--color-bg-hover);
  box-shadow: 0 2px 4px 0 rgba(15, 23, 42, 0.06);
}

.secondary[data-pressed] {
  box-shadow: none;
}

.secondary[data-disabled] {
  border-color: var(--color-border-subtle);
  background: transparent;
  color: var(--color-content-tertiary);
  box-shadow: none;
}

/* Text-like actions wrap like text instead of widening the layout. */
.tertiary {
  padding: 0 var(--space-2);
  white-space: normal;
  text-align: left;
  background: transparent;
  color: var(--color-content-secondary);
  font-weight: 500;
  /* A resting underline signals a text action without hover (touch, keyboard). */
  text-decoration: underline;
  text-decoration-color: var(--color-border-default);
  text-underline-offset: 3px;
}

.tertiary[data-hovered] {
  color: var(--color-content-primary);
  text-decoration-color: currentColor;
}

.tertiary[data-disabled] {
  color: var(--color-content-tertiary);
}
